// @flow

import React from 'react';
import classNames from 'classnames';
import { isNumber } from 'lodash';
import useSheet from 'app/jss';
import CircleButton from 'app/components/buttons/CircleButton';
import Icon from 'app/components/commons/Icon';

type Props = {
  onCancel?: () => void,
  onConfirm: () => void,
  sheet: object,
  className?: string,
  confirmIcon?: string,
  cancelIcon?: string,
  size?: number | string,
  iconSize?: number | string,
  hitboxSize?: number | string,
};

const defaultProps = {
  confirmIcon: 'icon-tick',
  cancelIcon: 'icon-cross',
  size: '2em',
  iconSize: undefined,
  className: undefined,
  hitboxSize: undefined,
  onCancel: undefined,
};

function ConfirmBox({
  className,
  onCancel,
  onConfirm,
  sheet: { classes },
  confirmIcon,
  cancelIcon,
  size,
  iconSize,
  hitboxSize,
}: Props) {
  const pixelSize = isNumber(size) ? `${size}px` : size;
  const sizeStyle = {
    height: pixelSize,
    width: pixelSize,
  };
  const iconStyle = {
    fontSize: iconSize,
  };
  return (
    <div className={classNames(classes.buttonContainer, className)}>
      <CircleButton
        className={classNames(classes.button, classes.confirm)}
        kind="success"
        onClick={onConfirm}
        style={sizeStyle}
        hitboxSize={hitboxSize}
      >
        <Icon type={confirmIcon} style={iconStyle} />
      </CircleButton>

      {onCancel && (
        <CircleButton
          kind="grey"
          className={classNames(classes.button, classes.cancel)}
          onClick={onCancel}
          style={sizeStyle}
          hitboxSize={hitboxSize}
        >
          <Icon type={cancelIcon} style={iconStyle} />
        </CircleButton>
      )}
    </div>
  );
}

ConfirmBox.defaultProps = defaultProps;

function applyStyles(theme) {
  return {
    buttonContainer: {
      display: 'flex',
      fontSize: 12,
      padding: theme.spacing.small,
      '& > *:not(:first-of-type)': {
        marginLeft: '1.5rem',
      },
    },
  };
}

export default useSheet(applyStyles)(ConfirmBox);
